export const HOME_CARD_CONTENT = {
  loggingDiscipline: {
    title: "Timesheet Discipline",
    description:
      "Measures how consistently timesheets are logged on time. The score is based on the percentage of working days where time was logged without requiring a timesheet unlock.",
  },
  approvalRate: {
    title: "Approval Rate",
    description:
      "Indicates the percentage of logged hours that have been approved. A higher score reflects better accuracy and fewer rejections in time entries.",
  },
  utilization: {
    title: "Utilization",
    description:
      "Shows how effectively available working hours are utilized. It compares total logged hours against total available hours.",
  },
  taskEfficiency: {
    title: "Task Efficiency",
    description:
      "Evaluates how efficiently tasks are completed compared to their expected timelines. Completing tasks faster than the due date results in a higher score.",
  },
  teamLoggingDiscipline: {
    title: "Team Timesheet Discipline",
    description:
      "Tracks how consistently team members log their work on time. The score is based on the percentage of working days where time was logged without delay.",
  },
  teamApprovalRate: {
    title: "Team Approval Rate",
    description:
      "Measures the proportion of logged work hours that have been approved. Calculated as: (Approved hours ÷ Total logged hours) × 100.",
  },
  teamUtilization: {
    title: "Team Utilization",
    description:
      "Represents how effectively the team's available time is utilized for productive work. Calculated as: (Total logged hours ÷ Available hours) × 100, derived from present days.",
  },
  billingDelay: {
    title: "Billable Collection",
    description:
      "Measures the percentage of billables collected within the allowed payment window. Billables collected after the due date plus the defined grace period are considered delayed and negatively impact the score.",
  },
  clientRetention: {
    title: "Client Retention",
    description:
      "Shows the percentage of clients retained from the previous financial year. Calculated as: (Retained clients ÷ Previous FY clients) × 100. Reflects client satisfaction, relationship management, and account stability.",
  },
  businessGeneration: {
    title: "Business Generation",
    description:
      "Represents the total revenue managed or owned by the Account Manager across all assigned accounts. This reflects portfolio size and revenue responsibility, but does not indicate performance or growth by itself.",
  },
  jobCompletionScore: {
    title: "Job Completion",
    description:
      "Indicates how often jobs are completed on time without extensions. Calculated as: (On-time jobs ÷ Total jobs) × 100. A higher percentage reflects strong execution, planning, and client satisfaction.",
  },
  deliverableQuality: {
    title: "Deliverable Quality",
    description:
      "Measures the quality, accuracy, completeness, and reliability of the delivered work against expectations.",
  },
  timelineAdherence: {
    title: "Timeline Adherence",
    description:
      "Evaluates how consistently the team met committed deadlines, milestones, and delivery schedules.",
  },
  communication: {
    title: "Communication",
    description:
      "Assesses the clarity, responsiveness, professionalism, and effectiveness of communication throughout the project.",
  },
  requirementClarity: {
    title: "Requirement Clarity",
    description:
      "Measures how well the team understood, captured, and executed the client’s business and project requirements.",
  },
  technicalQuality: {
    title: "Technical Quality",
    description:
      "Evaluates the technical expertise, solution reliability, scalability, and implementation quality demonstrated by the team.",
  },
  issueResolution: {
    title: "Issue Resolution",
    description:
      "Assesses how effectively and quickly the team handled bugs, blockers, escalations, and project challenges.",
  },
  projectManagement: {
    title: "Project Management",
    description:
      "Measures the effectiveness of project planning, coordination, tracking, prioritization, and overall execution.",
  },
  processCompliance: {
    title: "Process Compliance",
    description:
      "Evaluates adherence to agreed workflows, documentation standards, governance, and operational discipline.",
  },
  transparency: {
    title: "Transparency",
    description:
      "Assesses the visibility and openness maintained around project progress, risks, dependencies, and decision-making.",
  },
  postDeliverySupport: {
    title: "Post-Delivery Support",
    description:
      "Measures the quality, responsiveness, and effectiveness of support provided after deployment or delivery.",
  },
  marginAdherence: {
    title: "Margin Adherence",
    description:
      "Measures how closely the actual margin achieved across all managed jobs aligns with the overall budgeted margin.",
  }
};
